import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBitbucket = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "a",
		x1: "108.633%",
		x2: "46.927%",
		y1: "13.818%",
		y2: "78.776%",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: "18%",
			stopColor: "#0052CC"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: "100%",
			stopColor: "#2684FF"
		})]
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }),
			/* @__PURE__ */ _jsx("path", { d: "M9.912 14.997h4.176l1.007-5.884H8.802z" }),
			/* @__PURE__ */ _jsx("path", {
				fill: "#2684FF",
				fillRule: "nonzero",
				d: "M2.65 3.078a.641.641 0 0 0-.642.744l2.72 16.513c.07.417.43.724.853.727h13.05a.64.64 0 0 0 .64-.538l2.72-16.7a.64.64 0 0 0-.64-.743L2.649 3.078zm11.453 11.935H9.938L8.81 9.121h6.303l-1.01 5.892z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#a)",
				fillRule: "nonzero",
				d: "M19.11 6.113h-6.009L12.093 12H7.93l-4.915 5.833c.156.135.355.21.56.212H16.62a.64.64 0 0 0 .64-.538L19.11 6.113z",
				transform: "translate(2 3)"
			})
		]
	})]
});
export default SvgBitbucket;
